import { render, staticRenderFns } from "./mengBeanSummaryList.vue?vue&type=template&id=6ef641ac&scoped=true&lang=pug&"
import script from "./mengBeanSummaryList.vue?vue&type=script&lang=ts&"
export * from "./mengBeanSummaryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef641ac",
  null
  
)

export default component.exports